import { StyledPageMaintenance } from "./PageMaintenance.styled";
import { BodyTyp, TitlesTyp } from "../../../components/Typography/Typography";
import { FontWeightEnum } from "../../../types/AppTypes";
import { theme } from "../../../constants/StyledComponents";
import imageMaintenance from "../../../images/maintenance.svg";
import {
  MAINTENANCE_TITLE_LABEL,
  MAINTENANCE_MESSAGE_LABEL,
  RETRY_LABEL,
} from "../../../constants/Dictionary";
import { Button } from "../../../components/core/Button/Button";

type PageMaintenanceProps = {
  onRetry: () => void;
};

const PageMaintenance = ({ onRetry }: PageMaintenanceProps) => {
  return (
    <StyledPageMaintenance>
      <div className="maintenance-container">
        <div className="maintenance-header">
          <img src={imageMaintenance} width={350} />
        </div>
        <div className="maintenance-content">
          <TitlesTyp
            variant="1"
            fontWeight={FontWeightEnum.SEMIBOLD}
            color={theme.colors.black}
          >
            {MAINTENANCE_TITLE_LABEL}
          </TitlesTyp>
          <BodyTyp
            variant="1"
            fontWeight={FontWeightEnum.REGULAR}
            color={theme.colors.black}
          >
            {MAINTENANCE_MESSAGE_LABEL}
          </BodyTyp>
          <Button label={RETRY_LABEL} onClick={onRetry} />
        </div>
      </div>
    </StyledPageMaintenance>
  );
};

export default PageMaintenance;
